// import store from "../../../../store"

const sendBet = {
  name: "sendBet",
  data() {
    return {
      url: "",
      BtnSubimmtBet: false,
    };
  },
  computed: {
    retail() {
      return this.$store.state.operators.retail;
    },
  },
  methods: {
    initSendBet: function(url) {
      this.url = url;
      this.buildBet();
    },

    buildBet: function() {
      const odds = this.odds_selecteds.map((item) => {
        const { id_odd, odd_price, odd_price_margin } = item.data;
        return {
          id_odd,
          odd_price: odd_price_margin ? odd_price_margin : odd_price,
        };
      });

      const bet = {
        n_events: odds.length,
        value_bet: this.bet_amount,
        accept_odds_changes: this.accept_odds_changes,
        mobile: 0,
      };

      for (const [i, item] of odds.entries()) {
        const key_odds = Object.keys(item);
        const val_odds = Object.values(item);

        for (let j = 0; j < val_odds.length; j++) {
          bet[`${key_odds[j]}_${i + 1}`] = val_odds[j];
        }
      }

      // incrementa os campos de Anonymous (pré-aposta deslogado.)
      if (
        this.url === "/player/bets/betAnonymous" ||
        this.url === "/player/bets/betAnonymousNoSms"
      ) {
        sessionStorage.setItem("punter", this.nameOrPhonePreBet);
        this.anonymous.punter = this.nameOrPhonePreBet.replace(
          /[`~!@#$%^&*()_|+\-=?;:'",.<>/( )+/\{\}\[\]\\\/]/gi,
          ""
        ); // tirar a mascara
        Object.assign(bet, this.anonymous, {
          domain: this.$domain(),
        });
      }

      //

      this.sendBet(bet);
    },

    sendBet: function(bet) {
      this.BtnSubimmtBet = true;
      // Ativar ações de 'copiar' e compartilhar no 'whatsapp'
      // para as os endpoints especificos abaixo
      var activeActions =
        this.url === "/player/bets/betAnonymousNoSms" ||
        this.url === "/player/bets/preBet";

      var agentUrl =
        this.retail == 1
          ? "/agent/retail/bets/placeBet"
          : "/agent/bets/placeBet";

      const url = this.$isAgent() ? agentUrl : this.url;

      const postObj = this.$isAgent()
        ? {
            ...bet,
            ...{
              punter:
                typeof this.nameOrPhone == "object"
                  ? this.nameOrPhone.name
                  : this.nameOrPhone,
            },
          }
        : bet;
      this.$axios
        .post(url, this.$formdata(postObj))
        .then(async (resp) => {
          const {
            messages,
            credit_current,
            balance_bonus, // Valor de bonus evniado no response
            bonus_status, // Status de bonus evniado no response
            id_bet,
            value_prize,
            multiply,
          } = resp.data;
          await this.$store.commit("setFeedback", {
            title: id_bet,
            msg: messages,
            type: "success",
            action: this.$isAgent() ? "printBet" : "",
            id_bet,
            copy: activeActions,
            whatsapp: activeActions || this.$isAgent(),
            shareBetPDF: this.$isAgent(),
            validated: !activeActions,
          });
          if (this.logged.status) this.$store.commit("setCash", credit_current);
          // Envia o valor do bonus para o store
          if (this.isBonus) {
            this.$store.commit("setBonus", {
              value: balance_bonus,
              status: bonus_status,
            });
            this.isBonus = false;
          }
          // Novo registro para apostas a cobrar
          if (this.$isAgent() && typeof this.nameOrPhone == "string") {
            this.insertClientsAgents();
          }
          this.phone = "";

          if (
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
              navigator.userAgent
            )
          ) {
            navigator.vibrate([100, 200, 200, 200, 500]);
          }

          return { id_bet, value_prize, multiply, bonus_status };
        })
        .then((resp) => {
          // Register Event bet Google Analytics
          this.$gtag.handler_purchase(bet, this.odds_selecteds, resp, this.url);
          this.cleanCoupon();

          if (!this.$isAgent()) {
            this.redirectToBetSuccessRoute();
          }

          return resp;
        })
        // .then((resp) => {
        //   // if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        //   //   console.log('amigo estou aqui')
        //   //   this.cleanCouponIphone();
        //   // }
        //   this.$nextTick(() => {
        //     this.cleanCoupon();
        //   });
        // })
        .catch((err) => {
          this.error(err.response, "warning");
          this.BtnSubimmtBet = false;
        })
        .finally(() => {
          if (this.$vuetify.breakpoint.smAndDown) this.$emit("close");
          this.BtnSubimmtBet = false;
          this.loading = false;
        });
    },
    insertClientsAgents() {
      const body = {
        name_player: this.nameOrPhone ? this.nameOrPhone : "",
      };
      this.$axios
        .post("/agent/clients/insertClientsAgents", this.$formdata(body))
        .then((response) => {
          if (response.status === 200) {
            this.listClientsAgents();
            this.$store.commit("setNotification", {
              msg: response.data.dados,
              color: "green",
            });
          }
        })
        .catch((err) => {
          this.nameOrPhoneAlert = true;
          this.nameOrPhoneAlertAlertMsg = err.response.data.messages.error;
        });
    },
    // Lista Jogadores do Agente registrados para apostas a prazo
    // mo autocomplete
    listClientsAgents() {
      if (this.$isAgent()) {
        this.loading = true;

        this.$axios
          .get("/agent/clients/listClientsAgents")
          .then((response) => {
            if (response.status === 200) {
              this.fillAutocomplete = response.data.dados;
            }
          })
          .catch((err) => {
            if (err.response.data.status === 400) {
              // alert static
              this.alert = true;
              this.alertMsg = err.response.data.messages.error;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    error: function(error, color) {
      const { data, status } = error;

      const messages = {
        401: this.$t("pleaseLoginAgaing"),
        403: data.messages.messages,
        500: this.$t("serverErrorTryAgain"),
      };

      if (status === 408) {
        const msg = this.$t("playerHasregisterMsg");
        this.$store.commit("setFeedback", {
          title: this.$t("userFound"),
          msg,
          type: "info",
          action: "login",
        });
      } else if (status === 400) {
        const message = data.messages.error
          ? data.messages.error
          : data.messages[0].value_bet;
        this.$store.commit("setNotification", {
          msg: message || this.$t("phoneIsMandatory"),
          color,
        });
      } else {
        this.$store.commit("setNotification", {
          msg: messages[status],
          color,
        });

        status == 401 ? this.$logout() : null;
        status == 403 ? this.updateCartOdd(data.messages) : null;
      }
    },

    updateCartOdd: function(data) {
      const { dados, clear } = data;
      clear ? this.clearOdds(dados) : this.updatePriceOdds(dados);
    },

    clearOdds: function(dados) {
      const removedIds = dados.map((item) => item.id_odd);

      for (const id of removedIds) {
        this.odds_selecteds = this.odds_selecteds.filter(
          (item) => item.id_odd !== id
        );
        this.$store.commit("setCoupons", this.odds_selecteds);
      }
    },

    updatePriceOdds: function(dados) {
      for (const item of dados) {
        this.odds_selecteds.forEach((odd) => {
          if (odd.id_odd == item.id_odd) {
            odd.old_odd = odd.data.odd_price;
            odd.data.odd_price = item.odd_price;
            odd.data.odd_price_margin = item.odd_price;

            if (document.getElementsByClassName(item.id_odd)[0]) {
              document.getElementsByClassName(item.id_odd)[0].innerHTML =
                item.odd_price;
            }
            // Deprecated
            // this.$set(odd.data, "odd_price", item.odd_price);
            // this.$set(odd.data, "odd_price_margin", item.odd_price);
            // console.log(
            //   document.getElementsByClassName("old-value-" + item.id_odd)[0]
            //     .innerHTML
            // );
            // document.getElementsByClassName(
            //   "old-value-" + item.id_odd
            // )[0].innerHTML = document.getElementsByClassName(
            //   item.id_odd
            // )[0].innerHTML;
            // document.getElementsByClassName(item.id_odd)[0].innerHTML =
            //   item.odd_price;
            // if (document.getElementsByClassName(item.id_odd)[1] != undefined) {
            //   document.getElementsByClassName(item.id_odd)[1].innerHTML =
            //     item.odd_price;
            // }
          }
        });
        this.updateTotalOdds();
        this.$store.commit("setCoupons", this.odds_selecteds);
      }
    },

    redirectToBetSuccessRoute() {
      const currentRouteName = this.$route.name;
      const query = this.$route.query;
      const params = this.$route.params;
      let nextRoute = "";

      if (currentRouteName === "Sports") {
        nextRoute = "BetSuccessSports";
      } else if (currentRouteName === "bigTable") {
        nextRoute = "BetSuccessBt";
      } else if (currentRouteName === "category") {
        nextRoute = "BetSuccessEventsCategory";
      } else if (currentRouteName === "eventsCategory") {
        nextRoute = "BetSuccessEventsCategoryEvent";
      } else if (currentRouteName === "live") {
        nextRoute = "BetSuccessLive";
      } else if (currentRouteName === "eventsLive") {
        nextRoute = "BetSuccessLiveEvent";
      } else if (currentRouteName === "countries") {
        nextRoute = "BetSuccessCountries";
      } else if (currentRouteName === "eventsCountries") {
        nextRoute = "BetSuccessCountriesEvent";
      } else if (currentRouteName === "tournament") {
        nextRoute = "BetSuccessTournament";
      } else if (currentRouteName === "eventsTournament") {
        nextRoute = "BetSuccessTournamentEvent";
      } else if (currentRouteName === "worldCupWinner") {
        nextRoute = "BetSuccessWorldCupWinner";
      }

      this.$router.push({ name: nextRoute, query, params });
    },
  },
};

export default sendBet;
